<template>
    <div
        ref="modal-element"
        tabindex="-1"
        aria-hidden="true"
        class="fixed left-0 right-0 top-0 z-50 hidden h-[calc(100%-1rem)] max-h-full w-full overflow-y-auto overflow-x-hidden p-4 md:inset-0"
    >
        <div class="relative max-h-full w-full max-w-2xl">
            <div class="p-4 mb-4 text-sm text-anthrazit rounded-lg bg-white" role="alert" v-html="message"/>
        </div>
    </div>
</template>
<script>
import {Modal} from "flowbite"
import {useTemplateRef} from "vue"

export default {
    name: 'FormBuilderMessage',
    props: {
        form: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            eventHandlers: [],
            element: useTemplateRef('modal-element'),
            message: '<h1>Form submitted successfully</h1>',
        }
    },
    mounted() {
        const forms = document.querySelectorAll('[name="' + this.form + '"]')
        forms.forEach(form => {
            this.addEventListener(form)
        })
    },
    methods: {
        handleFormSuccessMessages(event) {
            const redirect = event.detail.redirect;
            const modal = new Modal(this.element, {
                placement: 'center-center',
                backdrop: 'dynamic',
                backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
                closable: true
            }, {
                override: false
            });

            if (event.detail.messages.length > 0) {
                this.message = event.detail.messages[0].message;
                modal.show();
                setTimeout(() => {
                    modal.hide();
                    if (redirect) {
                        document.location.href = redirect;
                    }
                }, 5000);
            } else if (redirect) {
                document.location.href = redirect;
            }
        },
        handleFormErrorMessages(event, messages, $form) {
            console.error(messages)
        },
        handleFormErrorFieldMessages(event) {
            event.detail.field.scrollIntoView({ behavior: 'smooth'});
        },
        handleFormFailMessages(event, response) {
            console.error(response)
        },
        addEventListener(form) {
            form.addEventListener('formbuilder.success', this.handleFormSuccessMessages.bind(this))
            form.addEventListener('formbuilder.error', this.handleFormErrorMessages.bind(this))
            form.addEventListener('formbuilder.error-field', this.handleFormErrorFieldMessages.bind(this))
            form.addEventListener('formbuilder.fatal', this.handleFormFailMessages.bind(this))
        }
    }
}
</script>
